module.exports = __webpack_public_path__ + "img/appfutura-badge.6e42cff0.png";